<template>
  <div class="excel-upload">
    <input
      v-if="clearFrom"
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
    <el-button class="custom-search-btn" @click="handleUpload"
      ><span class="down-icon-green"></span> 导入客户单号</el-button
    >
  </div>
</template>

<script>
// import XLSX from 'xlsx';

export default {
  props: {
    succeed: Function // eslint-disable-line
  },
  data() {
    return {
      clearFrom: true
    };
  },
  methods: {
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$message.error('只能上传 .xlsx,.xls 类型的文件');
        return false;
      }
      if (!rawFile) return;
      this.clearFrom = false;
      let fd = new FormData();
      fd.append('file', rawFile);
      this.upload(fd);
    },
    upload(fd) {
      this.$emit('succeed', { fd }, () => {
        this.clearFrom = true;
      });
    },
    isExcel(file) {
      return /\.(xlsx|xls)$/.test(file.name);
    }
  }
};
</script>

<style scoped>
.excel-upload {
  display: inline-block;
}
.excel-upload-input {
  display: none;
  z-index: -9999;
}
</style>
